import React from 'react';
import HeaderAndValue from 'components/headers/HeaderAndValue';
import './fieldWithIcon.scss';

import Button, {
	ButtonColor,
} from 'components/button';

interface Props {
	icon: JSX.Element;
	header: string;
	description: JSX.Element | string | number;
	onClick?: () => void;
}

export const FieldWithIcon = ({
	icon,
	header,
	description,
	onClick,
}: Props) => (
	<div className="transport-item">
		<div className="transport-item-list">
			<HeaderAndValue
				header={header}
				value={(
					<div className="field-description-and-icon">
						<div className="field-icon">
							{icon}
						</div>
						<div className="field-description">
							{description}
						</div>
					</div>
				)}
			/>
		</div>

		{onClick && (
			<div className="transport-item-button-area">
				<Button
					color={ButtonColor.INFO}
					onClick={onClick}
				>
					Vis alle {header.toLowerCase()}
				</Button>
			</div>
		)}
	</div>
);